// wjk 2017/11/20
/* global u $ __ ko */
import { Get } from 'common'
import uMessage from 'components/message'
function init (refer, obj) {
  $('#qualifyResultRefer .u-msg-footer').hide()
  let vm
  debugger
  let applyFieldId = refer.params.applyFieldId
  let applyId = refer.params.applyId
  let certCurrentStep = refer.params.certCurrentStep
  let productTestId = refer.params.productTestId
  vm = {
    continueText: ko.observable(''),
    continueCert: function () {
      if (certCurrentStep == 2) {
        window.location.href = `../applyFieldEdit/index.${__('locale')}.html?id=` + applyFieldId + '&editpage=true&certClickStep=2'
      } else if (certCurrentStep == 3) {
        window.location.href = `../productTestEdit/index.${__('locale')}.html?id=` + productTestId + '&editpage=true&certClickStep=3'
      }
    },
    overCert: async function () {
      let result = await Get('/cpu-supplymgr/certificationApply/finishStep/' + applyId)
      debugger
      if (result.status == 1) {
        window.location.href = '../ag_hierarchicalEdit/index.' + __('locale') + '.html?id=' + applyId + '&editpage=true'
      } else {
        uMessage('fail', result.msg)
      }
    },
    closeCert: function () {
      window.location.href = '../ag_hierarchicalEdit/index.' + __('locale') + '.html?id=' + applyId + '&editpage=true'
    }
  }
  debugger
  if (certCurrentStep == 2) {
    vm.continueText('继续现场认证')
  } else if (certCurrentStep == 3) {
    vm.continueText('继续产品试验')
  }
  let app = u.createApp()
  app.init(vm, $('#qualify_Result_Refer')[0])
  refer.registerSubmitFunc(() => {
    return vm
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/qualifyResultRefer/index.js